import { createSelector } from 'reselect';
import { createErrorDataSelector } from 'selectors/selectorUtils';


const getSelectedEvent = ({ eventLog }) => {
    return eventLog.selectedEvent;
};

const getEventComments = ({ eventDetailsSS }) => {
    return eventDetailsSS.eventComments;
};

const getEventClosingLoadingStatus = ({ eventLog }) => {
    return eventLog.eventClosingLoadingStatus;
};

const getUser = ({ overview }) => {
    return overview.user?.data;
};

const getEventCommentsRawError = ({ eventDetailsSS }) => {
    const eventComments = eventDetailsSS?.eventComments;
    return {
        loadingStatus: eventComments?.loadingStatus,
        error: eventComments?.error,
        errorCode: eventComments?.error?.statusCode
    };
};

const getPostCommentRawError = ({ eventDetailsSS }) => {
    const postEventComment = eventDetailsSS?.postEventComment;
    return {
        loadingStatus: postEventComment?.loadingStatus,
        error: postEventComment?.error,
        errorCode: postEventComment?.error?.statusCode
    };
};

const getCloseEventRawError = ({ eventDetailsSS }) => {
    const closeEventLog = eventDetailsSS?.closeEventLog;
    return {
        loadingStatus: closeEventLog?.loadingStatus,
        error: closeEventLog?.error,
        errorCode: closeEventLog?.error?.statusCode
    };
};

const getEventCommentsErrorData = createErrorDataSelector(getEventCommentsRawError);
const getPostCommentErrorData = createErrorDataSelector(getPostCommentRawError);
const getCloseEventErrorData = createErrorDataSelector(getCloseEventRawError);

const getEventDetailsSSRawError = createSelector([
    getEventCommentsErrorData,
    getPostCommentErrorData,
    getCloseEventErrorData
], (eventCommentsErrorData, postCommentErrorData, closeEventErrorData) => {
    if (eventCommentsErrorData?.loadingStatus === 'error' && eventCommentsErrorData?.error) {
        return eventCommentsErrorData;
    }
    if (postCommentErrorData?.loadingStatus === 'error' && postCommentErrorData?.error) {
        return postCommentErrorData;
    }
    return closeEventErrorData;
});

const getEventDetailsSSErrorData = createErrorDataSelector(getEventDetailsSSRawError);

export const getModel = createSelector([
    getSelectedEvent,
    getEventComments,
    getEventClosingLoadingStatus,
    getUser,
    getEventDetailsSSErrorData
], (
    selectedEvent,
    eventComments,
    eventClosingLoadingStatus,
    user,
    eventCommentsErrorData
) => {
    return {
        selectedEvent,
        eventComments,
        eventClosingLoadingStatus,
        user,
        eventCommentsErrorData
    };
});
